// @flow
export const dataKey: 'sales' = 'sales';
